import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { Pagination } from 'contracts/Pagination';
import { PaginatedPlanner } from 'contracts/Planners';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_PLANNERS_',
  }
);

export interface PaginatePlannersState {
  data: PaginatedPlanner[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginatePlannersRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedPlanner[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginatePlannersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginatePlannersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginatePlannersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginatePlannersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginatePlannersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginatePlanners = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginatePlannersTypes = Types;
export const PaginatePlannersActions = Creators;
